var render, staticRenderFns
import script from "./EventParticipantForm.vue?vue&type=script&lang=js"
export * from "./EventParticipantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EventParticipantForm.vue?vue&type=custom&index=0&blockType=b-card&%3Atitle=titleForm"
if (typeof block0 === 'function') block0(component)

export default component.exports